import TextareaWithLabelAndValidation from './TextareaWithLabelAndValidation'

export default TextareaWithLabelAndValidation
